import {
  CommentAction,
  CommentsState,
  DO_FETCH_COMMENTS,
  FAIL_COMMENTS,
  LOAD_COMMENTS,
  PERSIST_COMMENT,
  REMOVE_COMMENT,
} from "./CommentTypes";
import _ from "lodash";
import {
  failedStatus,
  loadingStatus,
  succeededStatus,
} from "../redux/LoadStatus";

const initialState: CommentsState = {
  synching: {},
  loadStatus: {},
  items: {},
};

export default function commentsReducer(
  state = initialState,
  action: CommentAction
): CommentsState {
  switch (action.type) {
    case DO_FETCH_COMMENTS: {
      const year = action.year;
      const month = action.month;
      const newState = { ...state };
      _.defaultsDeep(newState.synching, { [year]: { [month]: false } });
      _.defaultsDeep(newState.loadStatus, { [year]: { [month]: undefined } });
      newState.synching[`${year}`][`${month}`] = true;
      newState.loadStatus[`${year}`][`${month}`] = loadingStatus();
      return newState;
    }
    case LOAD_COMMENTS: {
      const year = action.year;
      const month = action.month;
      const newState = { ...state };
      delete newState.synching[`${year}`]?.[`${month}`];
      if (Object.keys(newState.synching[`${year}`] || {}).length < 1) {
        delete newState.synching[`${year}`];
      }
      _.defaultsDeep(newState.loadStatus, { [year]: { [month]: undefined } });
      newState.loadStatus[`${year}`][`${month}`] = succeededStatus(
        action.loadedAt
      );
      _.defaultsDeep(newState.items, { [year]: { [month]: {} } });
      newState.items[`${year}`][`${month}`] = action.items;
      return newState;
    }
    case FAIL_COMMENTS: {
      const year = action.year;
      const month = action.month;
      const newState = { ...state };
      delete newState.synching[`${year}`]?.[`${month}`];
      if (Object.keys(newState.synching[`${year}`] || {}).length < 1) {
        delete newState.synching[`${year}`];
      }
      _.defaultsDeep(newState.loadStatus, { [year]: { [month]: undefined } });
      newState.loadStatus[`${year}`][`${month}`] = failedStatus(action.error);
      return newState;
    }
    case REMOVE_COMMENT: {
      const year = action.year;
      const month = action.month;
      const newState = { ...state };
      _.defaultsDeep(newState.synching, { [year]: { [month]: false } });
      _.defaultsDeep(newState.loadStatus, { [year]: { [month]: undefined } });
      newState.synching[`${year}`][`${month}`] = true;
      newState.loadStatus[`${year}`][`${month}`] = loadingStatus();
      return newState;
    }
    case PERSIST_COMMENT: {
      const year = action.year;
      const month = action.month;
      const newState = { ...state };
      _.defaultsDeep(newState.synching, { [year]: { [month]: false } });
      _.defaultsDeep(newState.loadStatus, { [year]: { [month]: undefined } });
      newState.synching[`${year}`][`${month}`] = true;
      newState.loadStatus[`${year}`][`${month}`] = loadingStatus();
      return newState;
    }
    default:
      return state;
  }
}
